import { clsx } from "clsx";

export default function Container(props: {
  children?: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={clsx(
        "grid gap-x-8 grid-cols-12 gap-y-12",
        props.className ? props.className : ""
      )}
    >
      {props.children}
    </div>
  );
}
